module.exports = __webpack_public_path__ + "media/images/get-involved/stem-611224bc894fb78a428933817b71e53a.svg";